// Function component (presentational):

import React from 'react'

import LayoutWrapper from '../shared/styledComponents/page/LayoutWrapper'
import PageWrapper from '../shared/styledComponents/page/PageWrapper'

import NavContainer from '../nav/NavContainer'
import LibraContainer from '../libra/LibraStatefulContainer'
import DashboardContainer from '../dashboard/DashboardContainer'

import LibraryContainer from './LibraryStatefulContainer'

import { Layout } from 'antd'

const LibraryView = () => (
	<LayoutWrapper>
		<Layout>
			<NavContainer isHub />

			<PageWrapper>
				<LibraryContainer />
			</PageWrapper>

			<LibraContainer />
		</Layout>

		<DashboardContainer />
	</LayoutWrapper>
)

export default LibraryView
